import type {
  useInteractions,
  UseFloatingReturn,
} from "@floating-ui/react"
import type {
  Ref,
  RefObject,
} from "react"
import { createContext } from "react"
import type { Reading } from "src/types"

export interface TooltipContextValue extends UseFloatingReturn, ReturnType<typeof useInteractions> {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  reading?: Reading;
  arrow: RefObject<HTMLDivElement | null>;
  // reference for the tooltip must be attached to the div containing the tooltip
  tooltipRef: Ref<HTMLDivElement>;
}

type ContextType = TooltipContextValue | null
export const TooltipContext = createContext<ContextType>(null)
